import { compareOperator } from "./compareValues";
import evaluateCondition from "./evaluateCondition";

// Function to evaluate filter data
export default function evaluateFilterData(item, filterData, type) {
  if (filterData === null || filterData === undefined || Array.isArray(filterData) && filterData.length === 0) {
      return true; // Pass through if data is null, undefined, or empty array
  }

  if (Array.isArray(filterData)) {
      return filterData.some(condition => {
          return typeof condition === 'object' ? evaluateCondition(item, condition, type) : 
            compareOperator("==", type, item, condition) ;
      });
  }

  return evaluateCondition(item, filterData, type);
}